/*
  Warenkorb-Schublade: Upselling-Schaltflaechen und Gratisversand-Anzeige.

  Lag bis 30.08.2026 als zwei Inline-Bloecke in snippets/cart-drawer.liquid und
  damit mit 16,4 kB im HTML JEDER Seite - die Schublade wird global gerendert,
  der Code lief also auch bei leerem Warenkorb im Dokument mit. Als Asset wird
  die Datei stattdessen vom CDN geladen und beim zweiten Seitenaufruf aus dem
  Browser-Cache bedient.

  Eingebunden in layout/theme.liquid unter derselben Bedingung wie
  cart-drawer.js (settings.cart_type == 'drawer') und mit defer. Das ist
  unschaedlich, weil beide Bloecke ohnehin auf DOMContentLoaded warten und
  defer-Skripte davor ausgefuehrt werden.

  Enthaelt bewusst KEINE Liquid-Ausdruecke - beide Bloecke waren bereits reines
  JavaScript, sonst waere die Auslagerung so nicht moeglich gewesen.

  Anmerkung fuer spaeter: ein erheblicher Teil setzt Stilwerte einzeln per
  element.style (29 Zuweisungen) und gehoerte eigentlich in eine Stylesheet-
  Datei. Der Rest ist echte Logik (fetch fuer Warenkorb-Zugabe, cart:updated,
  MutationObserver), deshalb bleibt es hier vorerst zusammen.
*/

document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.upsell-add-button');
  buttons.forEach(button => {
    button.style.setProperty('height', '36px', 'important');
    button.style.setProperty('min-height', '36px', 'important');
    button.style.setProperty('max-height', '36px', 'important');
    button.style.setProperty('line-height', '36px', 'important');
    button.style.setProperty('font-size', '14px', 'important');
    button.style.setProperty('font-weight', '500', 'important');
    button.style.setProperty('border-radius', '20px', 'important');
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const BUTTON_CLASS = 'custom-upsell-button';
  function forceButtonStyles() {
    document.querySelectorAll('.upsell-add-button').forEach(button => {
      button.classList.remove('button', 'button--tertiary');
      button.classList.add(BUTTON_CLASS);
      const textAdd = button.dataset.textAdd || 'Add';
      const textAdded = button.dataset.textAdded || 'Added';
      if (button.textContent.trim() !== textAdded) {
        button.style.backgroundColor = '#F0EAE4';
      }
      button.style.border = 'none';
      button.style.borderRadius = '15px';
      button.style.width = '100%';
      button.style.height = '20px';
      button.style.minHeight = '20px';
      button.style.maxHeight = '20px';
      button.style.lineHeight = '20px';
      button.style.fontSize = '11px';
      button.style.color = '#1A1A1A';
      button.style.fontWeight = '500';
      button.style.boxShadow = 'none';
      button.style.margin = '0';
      button.style.padding = '0';
      button.style.textTransform = 'none';
      button.style.display = 'block';
      button.style.textAlign = 'center';
    });
  }

  function addCustomButtonStyles() {
    if (!document.getElementById('upsell-custom-styles')) {
      const styleElement = document.createElement('style');
      styleElement.id = 'upsell-custom-styles';
      styleElement.textContent = `
        .${BUTTON_CLASS} {
          border: none !important;
          border-radius: 15px !important;
          width: 100% !important;
          height: 20px !important;
          min-height: 20px !important;
          max-height: 20px !important;
          line-height: 20px !important;
          font-size: 11px !important;
          color: #1A1A1A !important;
          font-weight: 500 !important;
          box-shadow: none !important;
          margin: 0 !important;
          padding: 0 !important;
          text-transform: none !important;
          display: block !important;
          text-align: center !important;
        }

        .${BUTTON_CLASS}:not(:disabled) {
          background-color: #F0EAE4 !important;
        }

        .${BUTTON_CLASS}.added-state {
          background-color: #D4E2D1 !important;
        }
      `;
      document.head.appendChild(styleElement);
    }
  }

  function updateButtonState(button, isAdded) {
    const textAdd = button.dataset.textAdd || 'Add';
    const textAdded = button.dataset.textAdded || 'Added';
    if (isAdded) {
      button.textContent = textAdded;
      button.disabled = true;
      button.style.backgroundColor = '#D4E2D1';
      button.classList.add('added-state');
    } else {
      button.textContent = textAdd;
      button.disabled = false;
      button.style.backgroundColor = '#F0EAE4';
      button.classList.remove('added-state');
    }
  }

  addCustomButtonStyles();
  forceButtonStyles();

  function handleAddToCart(event) {
    const button = event.currentTarget;
    button.removeEventListener('click', handleAddToCart);

    const variantId = button.closest('.add-upsell-to-cart').dataset.variantId;

    updateButtonState(button, true);

    const formData = {
      'items': [{
        'id': variantId,
        'quantity': 1
      }],
      'sections': "cart-drawer,cart-icon-bubble"
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(response => {
      if (typeof window.updateQuantity === 'function') {
        window.updateQuantity('update', variantId, 1);
      }

      const cartDrawerItems = document.querySelector('cart-drawer-items');
      if (cartDrawerItems) {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { 
              source: 'quantity-update'
            }
          })
        );

        if (response.sections && response.sections['cart-drawer']) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(response.sections['cart-drawer'], 'text/html');

          const newItems = doc.querySelector('cart-drawer-items');
          if (newItems) {
            cartDrawerItems.innerHTML = newItems.innerHTML;
          }

          const currentFooter = document.querySelector('.drawer__footer');
          const newFooter = doc.querySelector('.drawer__footer');
          if (currentFooter && newFooter) {
            currentFooter.innerHTML = newFooter.innerHTML;
          }

          forceButtonStyles();
        }
      }

      fetch(window.Shopify.routes.root + 'cart.js')
        .then(res => res.json())
        .then(cart => {
          const totalValueElements = document.querySelectorAll('.totals__total-value');
          if (totalValueElements.length > 0) {
            totalValueElements.forEach(el => {
              const formattedPrice = formatMoney(cart.total_price);
              el.textContent = formattedPrice;
            });
          }

          updateShippingThresholdUI(cart.total_price);
          attachUpsellingEventListeners();
        })
        .catch(error => {
          console.error('Error fetching cart data:', error);
        });

      setTimeout(() => {
        updateButtonState(button, false);
        button.addEventListener('click', handleAddToCart);
      }, 2000);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      const textError = button.dataset.textError || 'Error';
      button.textContent = textError;

      setTimeout(() => {
        updateButtonState(button, false);
        button.addEventListener('click', handleAddToCart);
      }, 2000);
    });
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }

    const amount = cents / 100;
    return '€ ' + amount.toFixed(2).replace('.', ',');
  }

  function updateShippingThresholdUI(totalPrice) {
    fetch(window.location.pathname + '?sections=cart-drawer')
      .then(response => response.json())
      .then(data => {
        if (data['cart-drawer']) {
          const parser = new DOMParser();
          const newCartDoc = parser.parseFromString(data['cart-drawer'], 'text/html');

          const currentShippingContainer = document.querySelector('[style*="background: linear-gradient(135deg, #F5F3F1"], [style*="background: linear-gradient(135deg, #e8f0e6"], [style*="background: linear-gradient(135deg, #fdf0f2"], .shipping-threshold-container');

          const newShippingContainer = newCartDoc.querySelector('[style*="background: linear-gradient(135deg, #F5F3F1"], [style*="background: linear-gradient(135deg, #e8f0e6"], [style*="background: linear-gradient(135deg, #fdf0f2"], .shipping-threshold-container');

          if (currentShippingContainer && newShippingContainer) {
            currentShippingContainer.outerHTML = newShippingContainer.outerHTML;
          }

          forceButtonStyles();
        }
      })
      .catch(error => {
        console.error('Error updating shipping threshold:', error);
        manualUpdateShippingUI(totalPrice);
      });
  }

  function manualUpdateShippingUI(totalPrice) {
    const freeShippingThreshold = 7500;
    const remainingAmount = Math.max(0, freeShippingThreshold - totalPrice);
    const progressPercentage = Math.min(100, (totalPrice * 100) / freeShippingThreshold);

    const shippingContainers = document.querySelectorAll('[style*="background: linear-gradient(135deg, #F5F3F1"], [style*="background: linear-gradient(135deg, #e8f0e6"], [style*="background: linear-gradient(135deg, #fdf0f2"], .shipping-threshold-container');

    shippingContainers.forEach(container => {
      try {
        const textElements = container.querySelectorAll('span, div');
        textElements.forEach(el => {
          if (el.textContent.includes('weitere') || el.textContent.includes('Gratulation') || el.textContent.includes('Mindestbestellwert') || el.textContent.includes('Congratulations') || el.textContent.includes('Minimum') || el.textContent.includes('until')) {
            if (totalPrice >= freeShippingThreshold) {
              if (container.querySelector('[style*="#2D5A2D"]')) {
                el.innerHTML = document.documentElement.lang === 'en' ? 'Minimum order value reached!' : 'Mindestbestellwert erreicht!';
              } else {
                el.innerHTML = document.documentElement.lang === 'en' ? 'Congratulations! Your shipping is free!' : 'Gratulation! Dein Versand ist kostenlos!';
              }
            } else {
              const formattedAmount = new Intl.NumberFormat('de-DE', { 
                style: 'currency', 
                currency: 'EUR' 
              }).format(remainingAmount / 100);

              if (container.querySelector('[style*="#8B3A50"]')) {
                el.innerHTML = document.documentElement.lang === 'en' 
                  ? `Another <strong style="font-size: 1.1em;">${formattedAmount}</strong> until shipping`
                  : `Bestelle für weitere <strong style="font-size: 1.1em;">${formattedAmount}</strong>, um versenden zu können`;
              } else {
                el.innerHTML = document.documentElement.lang === 'en'
                  ? `Only <strong style="color: #A04B60;">${formattedAmount}</strong> until <strong style="color: #3D6B3D;">free shipping</strong>!`
                  : `Noch <strong style="color: #A04B60;">${formattedAmount}</strong> bis zum <strong style="color: #3D6B3D;">kostenlosen Versand</strong>!`;
              }
            }
          }
        });

        const allDivs = container.querySelectorAll('div');

        allDivs.forEach(div => {
          const style = window.getComputedStyle(div);

          if (style.background.includes('linear-gradient(90deg, #A04B60') || 
              div.style.background.includes('linear-gradient(90deg, #A04B60') ||
              style.background.includes('linear-gradient(90deg, #5B8C5A') || 
              div.style.background.includes('linear-gradient(90deg, #5B8C5A')) {
            if (totalPrice >= freeShippingThreshold) {
              div.style.width = '100%';
            } else {
              div.style.width = `${progressPercentage}%`;
            }
          }

          if (style.backgroundColor === 'rgba(212, 208, 204, 0.6)' || 
              div.style.backgroundColor === 'rgba(212, 208, 204, 0.6)') {
            div.style.width = `${100 - progressPercentage}%`;
          }
        });

        const truckContainers = container.querySelectorAll('[style*="position: absolute"]');

        truckContainers.forEach(truckContainer => {
          if (truckContainer.querySelector('.svg-wrapper') || 
              truckContainer.innerHTML.includes('truck') ||
              truckContainer.textContent.includes('✓') ||
              truckContainer.textContent.includes('📦')) {

            if (totalPrice >= freeShippingThreshold) {
              truckContainer.style.left = '';
              truckContainer.style.right = '-4px';
              truckContainer.style.transform = '';
            } else {
              truckContainer.style.right = '';
              truckContainer.style.left = `${progressPercentage}%`;
              truckContainer.style.transform = 'translateX(-50%)';
            }
          }
        });
      } catch (err) {
        console.error('Error in manual update:', err);
      }
    });

    forceButtonStyles();
  }

  function attachUpsellingEventListeners() {
    document.querySelectorAll('.upsell-add-button').forEach(button => {
      button.removeEventListener('click', handleAddToCart);
      button.addEventListener('click', handleAddToCart);
    });

    forceButtonStyles();
  }

  attachUpsellingEventListeners();

  document.addEventListener('cart:updated', function() {
    attachUpsellingEventListeners();
  });

  const cartObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'subtree') {
        attachUpsellingEventListeners();
      }
    });
  });

  const cartDrawer = document.getElementById('CartDrawer');
  if (cartDrawer) {
    cartObserver.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }

  document.querySelectorAll('.cart-remove-button').forEach(removeButton => {
    removeButton.addEventListener('click', function() {
      setTimeout(function() {
        attachUpsellingEventListeners();
        forceButtonStyles();
      }, 500);
    });
  });

  setInterval(forceButtonStyles, 1000);
});
